export default {
  viewGoods: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000683","查看商品") /* "查看商品" */,
  referCaption: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000684","商品") /* "商品" */
};
